export interface NotificationTemplate {
  devices: string[];
  editable: boolean;
  id: string;
  name: string;
  users?: string[];
}

export const DEFAULT_NOTIFICATION_TEMPLATE_ID = 'all-devices';
